/* ============================================================================
   layout-resize.js - ignore iOS Safari height-only resize (URL bar show/hide)
   ============================================================================ */

/**
 * Run callback when layout width changes (rotation, split view), not when iOS
 * only changes viewport height while scrolling.
 */
export function onLayoutWidthChange(callback, { debounceMs = 150 } = {}) {
  if (typeof window === "undefined" || typeof callback !== "function") {
    return () => {};
  }

  let lastWidth = window.innerWidth;
  let timer = null;

  const run = () => {
    const width = window.innerWidth;
    if (width === lastWidth) return;
    lastWidth = width;
    window.clearTimeout(timer);
    timer = window.setTimeout(() => callback(width), debounceMs);
  };

  window.addEventListener("resize", run, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", run, { passive: true });
  }

  return () => {
    window.removeEventListener("resize", run);
    window.visualViewport?.removeEventListener("resize", run);
    window.clearTimeout(timer);
  };
}

export function isIOSWebKit() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return navigator.platform === "MacIntel" && Number(navigator.maxTouchPoints || 0) > 1;
}
